import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { errorSelector } from '../../selectors/app';
import Notification from './Notification';
import { changeConfigChildRoute } from '../../../home/actions/config';
import { showGlobalError } from '../../actions/app';

const mapStateToProps = createStructuredSelector({
    error: errorSelector,
});

const mapDispatchToProps = { changeConfigChildRoute, showGlobalError };

export default connect(mapStateToProps, mapDispatchToProps)(Notification);